__turbopack_context__.v({
  "container": "klab-foundation-section-module__svJ8vG__container",
  "content": "klab-foundation-section-module__svJ8vG__content",
  "header": "klab-foundation-section-module__svJ8vG__header",
  "label": "klab-foundation-section-module__svJ8vG__label",
  "learnMore": "klab-foundation-section-module__svJ8vG__learnMore",
  "quote": "klab-foundation-section-module__svJ8vG__quote",
  "quoteLine": "klab-foundation-section-module__svJ8vG__quoteLine",
  "quoteLineBar": "klab-foundation-section-module__svJ8vG__quoteLineBar",
  "quoteLineText": "klab-foundation-section-module__svJ8vG__quoteLineText",
  "section": "klab-foundation-section-module__svJ8vG__section",
});
